import { useState } from 'react';
import Button from './Button';
import Board from './Board';
import './App.css';

import LogoUrl from './assets/logo.png';

function random(n) {
	return Math.ceil(Math.random() * n);
}

function App() {
	const [myHistory, setMyHistory] = useState([]);
	const [otherHistory, setOtherHistory] = useState([]);

	const handleRollClick = () => {
		const nextMyNum = random(6);
		const nextOtherNum = random(6);
		const Me = document.querySelector('.Board[data-check="me"]');
		const Other = document.querySelector('.Board[data-check="other"]');
		setMyHistory([...myHistory, nextMyNum]);
		setOtherHistory([...otherHistory, nextOtherNum]);
		nextMyNum > nextOtherNum ? winMe(Me, Other) : nextMyNum < nextOtherNum ? winOther(Me, Other) : noWin(Me, Other);
	};

	const handleClearClick = () => {
		setMyHistory([]);
		setOtherHistory([]);
		let boardLists = document.querySelectorAll('.Board[data-check]');
		boardLists.forEach((board) => {
			board.classList.remove('Board-winner');
		});
	};

	function winMe(Me, Other) {
		Me.classList.add('Board-winner');
		Other.classList.remove('Board-winner');
	}

	function winOther(Me, Other) {
		Me.classList.remove('Board-winner');
		Other.classList.add('Board-winner');
	}

	function noWin(Me, Other) {
		Other.classList.remove('Board-winner');
		Me.classList.remove('Board-winner');
	}

	return (
		<div className="App">
			<div>
				<img className="App-logo" src={LogoUrl} alt="주사위게임 로고" />
				<h1 className="App-title">주사위게임</h1>
				<div>
					<Button className="App-button" color="blue" onClick={handleRollClick}>
						던지기
					</Button>
					<Button className="App-button" color="red" onClick={handleClearClick}>
						처음부터
					</Button>
				</div>
			</div>
			<div className="App-boards">
				<Board name="나" color="blue" gameHistory={myHistory} dataCheck="me" />
				<Board name="상대" color="red" gameHistory={otherHistory} dataCheck="other" />
			</div>
		</div>
	);
}

export default App;
